import { Button, Col, Form, Input, Row, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import {
    jobService,
} from "_services";

function Search(props) {
    const [form] = Form.useForm();

    const onFinish = (values) => {
        props.showSearchLoading(true);
        let searchParams = "";
        if (values.code) {
            searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
            searchParams += `code=${encodeURIComponent(values.code)}`;
        }
        if (values.description) {
            searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
            searchParams += `description=${encodeURIComponent(values.secondaryCode)}`;
        }
        jobService
            .search(searchParams)
            .then((data) => {
                props.onSearchResults(
                    data.content,
                    data.pagination.totalRecords,
                    searchParams
                );
            })
            .catch((error) => {
                message.error(`${error}`);
                props.onSearchResults([], null, searchParams);
            });
    };

    return (
        <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            className="search-form"
        >
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item name="code" label="Job Code">
                        <Input placeholder="Job Code" allowClear />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="description" label="Description">
                        <Input placeholder="Description" allowClear />
                    </Form.Item>
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                    <div>
                        <Button type="primary" htmlType="submit">
                            Search
                        </Button>
                        <Button
                            style={{ margin: "0 8px" }}
                            onClick={() => {
                                form.resetFields();
                                onFinish({});
                            }}
                        >
                            Clear
                        </Button>
                    </div>
                </Col>
            </Row>
        </Form>
    );
}

export default Search;
